import { Component } from '@angular/core';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.css']
})
/** access-denied component*/
export class AccessDeniedComponent {
  /** access-denied ctor */
  constructor() {

  }

  onBackClick() {
    //window.location.replace('https://localhost:44320/');
  }
}
